import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { ClickEvent, Menu, MenuItem } from "mds/components/Menu";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { ChevronDownIcon } from "mds/icons";

export type SectionViewOption = "course" | "term";

export type SectionViewOptionMenuProps = {
  selectedOption: SectionViewOption;
  onOptionChange: (option: SectionViewOption) => void;
  eventPrefix?: string;
};

const OPTIONS: { value: SectionViewOption; label: string }[] = [
  { value: "course", label: t("glossary.course") },
  { value: "term", label: t("glossary.term") },
];

export const SectionViewOptionMenu: FC<SectionViewOptionMenuProps> = ({
  selectedOption,
  onOptionChange,
  eventPrefix = "",
}) => {
  const selectedOptionData = OPTIONS.find((opt) => opt.value === selectedOption);
  const isSmallScreen = !useIsMdOrLarger();

  const onItemClick = (e: ClickEvent) => {
    const newOption = e.value as SectionViewOption;
    onOptionChange(newOption);
  };

  const menuButton = (
    <Button
      className={clsx(
        "flex items-center justify-between gap-1 text-black-tint-20",
        isSmallScreen ? "w-full" : "w-[206px]",
      )}
      kind="white"
      size="s"
    >
      {selectedOptionData?.value === "course" ? t("home.view_by_course") : t("home.view_by_term")}
      <ChevronDownIcon />
    </Button>
  );

  return (
    <Menu direction="bottom" menuButton={menuButton} position="initial">
      {OPTIONS.map((option) => {
        const selected = selectedOption === option.value;
        return (
          <MenuItem
            checked={selected}
            className={clsx(
              { selected, "text-white": selected },
              "center dropdown-item",
              isSmallScreen ? "w-[calc(100vw-6rem)]" : "w-[208px]",
            )}
            eventName={`${eventPrefix}Course view option selected`}
            eventProps={{ fieldValue: option.value }}
            key={option.value}
            value={option.value}
            onClick={onItemClick}
          >
            {option.label}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
